var React = require('react');

function CombinedShape (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#FFF"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M360 0c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm3.5 8.5H358V10h3l-5 5 1 1 5-5v3h1.5V8.5z","transform":"translate(-1392 -262) translate(1020) translate(24 262)"}))))));
}

CombinedShape.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CombinedShape;

CombinedShape.default = CombinedShape;
